module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00075.6db988ed.jpg";